import { useState, useCallback } from "react";

// 입력 타입에 따른 처리 로직 - 컴포넌트 외부로 이동하여 재생성 방지
const inputHandlers = {
  input: (e) => e.target.value,
  select: (e) => e,
  phoneNumberInput: (e) => e.target.value.replace(/[^0-9]/g, "").replace(/^(8210|010)(.+)$/, "8210$2")
};

/**
 * 입력 값 관리를 위한 심플한 커스텀 훅
 * @param {any} defaultValue - 초기 값
 * @param {"input"|"select"|"phoneNumberInput"} type - 입력 타입
 * @returns {[any, function, function]} - [현재값, 변경 함수, 초기화 함수]
 */
export function useInputs(defaultValue, type) {
  const [value, setValue] = useState(defaultValue);

  // 값 변경 함수
  const handleChange = useCallback((e) => {
    const handler = inputHandlers[type];
    if (handler) setValue(handler(e));
  }, [type]);

  // 초기화 함수
  const handleReset = useCallback(() => setValue(defaultValue), [defaultValue]);

  return [value, handleChange, handleReset];
}